import React from 'react';
import SEO from '../components/SEO/SEO';
import HeroBanner from '../components/HeroBanner/HeroBanner';
import QuoteFrom from '../components/QuoteFrom/QuoteFrom';
import Stories from '../components/Stories/Stories';
import WhatWeDo from '../components/WhatWeDo/WhatWeDo';
import Benefits from '../components/Benefits/Benefits';
import HomePageCharts from '../components/HomePageCharts/HomePageCharts';
const counselling = require('../assets/icons/counselling.svg');
const sicknessManagement = require('../assets/icons/sickness-management.svg');
const travelHealth = require('../assets/icons/travel-vaccine.svg');
const mobileApp = require('../assets/icons/mobile-app.svg');
const mobileAppointments = require('../assets/icons/mobile-appointment.svg');
const wellnessSeminars = require('../assets/icons/wellness-seminar.svg');
const healthCheck = require('../assets/icons/stethescope.svg');
const physiotherapy = require('../assets/icons/physiotherapy-2.svg');

const IndexPage = () => (
	<React.Fragment>
		<SEO
			title='Home'
			description='An innovative healthcare platform which allows businesses to get their employees ‘back to work’ faster. Reducing sick days and improving employee wellness is a caring way to boost business performance and productivity.'
		/>
		<HeroBanner
			imageSrc='tagline-img.png'
			imageAlt='Engineers working'
			title='Your Wellbeing Partner'
			tagline='We work with local health and wellness practices to give your employees easy access to a professional when they need it.'
		/>

		<WhatWeDo
			title='What We Do'
			subtitle='We provide a range of services to keep your workforce happy and healthy.'
			contentItems={[
				{
					imageSrc: sicknessManagement,
					title: 'Sickness Management',
					text: 'Employees absence assessment based on your sickness policy',
				},
				{
					imageSrc: travelHealth,
					title: 'Travel Health',
					text: 'Travel vaccinations and antimalarials to protect your health',
				},
				{
					imageSrc: wellnessSeminars,
					title: 'Wellness Seminars',
					text: 'Raise awareness and affect behavioural change',
				},
				{
					imageSrc: mobileAppointments,
					title: 'Video Appointments',
					text: 'Talk to a GP from your mobile phone',
				},
				{
					imageSrc: healthCheck,
					title: 'Annual Health Check',
					text: 'Proactive care for your employees',
				},
				{
					imageSrc: mobileApp,
					title: 'Mobile App',
					text: "Expert advice at your team's fingertips",
				},
				{
					imageSrc: physiotherapy,
					title: 'Physiotherapy Clinics',
					text: 'Fast access to video consultations, on-site services and local clinics',
				},
				{
					imageSrc: counselling,
					title: 'Mental Health Counselling',
					text: 'Professional Counselling to support employee mental wellness',
				},
			]}
		/>
		<Benefits
			title='We benefit you and your team'
			subtitle='Flexible health and wellbeing solutions starting from £2 per person per month'
			list={[
				'Low cost employee benefit for your team',
				'You have a healthier and happier workforce',
				'Employees take less time off work',
				'Employees have faster access to healthcare',
				'You have decreased administrative costs',
				'We manage sick leave and support return to work',
				'You have improved productivity and retention',
				'Employees no longer come to work whilst sick',
			]}
		/>
		<Stories
			transitionInterval={14000}
			stories={[
				{
					name: 'Roman',
					text:
						'Roman works on the manufacturing line. He’s amazing with his hands, but his hayfever slows him down every summer. With DocHQ, he receives a reminder about his allergies in spring and gets a prescription in time to beat the high pollen counts. Finally, he’s able to enjoy the sun as much as he enjoys his work.',
					imageSrc: 'roman.png',
				},
				{
					name: 'Debbie',
					text:
						'Debbie is responsible for a large number of employees and was finding retaining staff a real problem. Access to a low-cost employee engagement platform offers her staff perks and discounts, wellbeing tools, recognition and rewards as well as online learning. It has created a buzz around the business, increasing loyalty and enhancing skills.',
					imageSrc: 'debbie.png',
				},
				{
					name: 'Phil',
					text:
						'Phil often burns the candle at both ends. He’s a plumber and he’s in demand. The stress can often lead to chest infections. But now he’s signed up to DocHQ, a quick video phone call means a nurse can send a prescription to his local pharmacist within 24 hours. In no time, Phil is back to doing what he does best.',
					imageSrc: 'phil.png',
				},
				{
					name: 'Sophia',
					text:
						'As a director of a growing business, Sophia has a lot of bases to cover. The last thing she needs as she arrives in the morning is staff calling in sick. The sickness management service from DocHQ is ideal for dealing with just those calls. She finds the real-time data and reporting particularly helpful as it allows her to help her employees when they need it.',
					imageSrc: 'sophia.png',
				},
			]}
		/>
		<HomePageCharts />
		<QuoteFrom
			authorName='Madhur Srivastava'
			authorRole='CEO'
			authorCompany='DocHQ'
			authorImageSrc='madhur.jpg'
			quote={[
				'At DocHQ we want to help people to make informed health choices and inspire them to improve their quality of life. By providing fast medical support we can boost employee health and productivity.',
			]}
			backgroundColor='var(--doc-light-grey)'
		/>
	</React.Fragment>
);

export default IndexPage;
